const algoliaToggleFilters = {
  'attributes_translated.24_HOUR_DELIVERY': {
    count: 'TRUE',
  },
  'attributes_translated.RX_FILTER': {
    count: 'TRUE',
  },
}
export default algoliaToggleFilters
